<template>
  <div>
    <div
      class="d-flex flex-row text-primary-darken-1 justify-space-between align-top"
      :class="docHeader ? 'text-headline-large mb-1' : 'text-headline-medium'"
    >
      <div>{{ title }}</div>
      <div>
        <slot name="append" />
      </div>
    </div>
    <v-divider
      class="mt-2 mb-4"
      thickness="2"
      opacity="100"
    />
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ title: string; docHeader?: boolean }>(), {
  docHeader: () => false,
});
</script>
